import { isPlatformBrowser } from '@angular/common';
import {
  EnvironmentProviders,
  InjectionToken,
  PLATFORM_ID,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';
import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { ReCaptchaV3Provider, initializeAppCheck } from 'firebase/app-check';
import { Firestore, connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { environment } from '../../../environments/environment';

const firebaseOptions = {
  apiKey: 'AIzaSyBYw7S79Av5X3_xhvWjIE8oLtC-kG8VJAI',
  authDomain: 'lumiron-bubblesoccer.firebaseapp.com',
  databaseURL: 'https://lumiron-bubblesoccer-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'lumiron-bubblesoccer',
  storageBucket: 'lumiron-bubblesoccer.appspot.com',
  messagingSenderId: '990437382583',
  appId: '1:990437382583:web:5956b070c476eef3b97032',
  measurementId: 'G-G89Y7PD3RZ',
};

const RECAPTCHA_SITE_KEY = '6Lf0XbcfAAAAACMMNRs28Gu4gEDvSQ_M35Siq8gE';

export const FIREBASE_APP = new InjectionToken<FirebaseApp>('FIREBASE_APP');
export const FIRESTORE = new InjectionToken<Firestore>('FIRESTORE');

let emulatorConnected = false;

function getOrInitApp(): FirebaseApp {
  return getApps().length > 0 ? getApp() : initializeApp(firebaseOptions);
}

export function provideFirebase(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: FIREBASE_APP, useFactory: getOrInitApp },
    {
      provide: FIRESTORE,
      useFactory: () => {
        const app = inject(FIREBASE_APP);
        const firestore = getFirestore(app);
        if (!environment.production && !emulatorConnected) {
          connectFirestoreEmulator(firestore, 'localhost', 8080);
          emulatorConnected = true;
        }
        return firestore;
      },
    },
    provideEnvironmentInitializer(() => {
      if (!isPlatformBrowser(inject(PLATFORM_ID))) {
        return;
      }
      initializeAppCheck(inject(FIREBASE_APP), {
        provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
        isTokenAutoRefreshEnabled: true,
      });
    }),
  ]);
}
